import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../styles/RegistroObsequios.css';
const api = axios.create({ baseURL: process.env.REACT_APP_API || '', withCredentials: true });
const readGifts = data => Array.isArray(data?.gifts) ? data.gifts : Array.isArray(data?.data) ? data.data : [];
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` } });
export default function RegistroObsequios({ registerId, count = 0, role }) {
  const permitted = [1, 3, 8, 10].includes(Number(role));
  const [open,setOpen] = useState(false);
  const [detectedCount,setDetectedCount] = useState(Number(count)||0);
  const [rows,setRows] = useState([]);
  const [error,setError] = useState('');
  const [loading,setLoading] = useState(false);
  useEffect(()=>{
    if (!registerId || !permitted) return;
    let alive=true;
    api.get(`/promotions/register/${registerId}/gifts`, auth()).then(({data})=>{
      if(alive) setDetectedCount(readGifts(data).length);
    }).catch(()=>{if(alive)setDetectedCount(Number(count)||0);});
    return ()=>{alive=false;};
  },[registerId,count,permitted]);
  useEffect(()=>{ if(!open||!registerId||!permitted)return; let alive=true; setLoading(true);setError('');
    api.get(`/promotions/register/${registerId}/gifts`, auth()).then(({data})=>{if(alive)setRows(readGifts(data));}).catch(()=>{if(alive)setError('No se pudo consultar el detalle.');}).finally(()=>{if(alive)setLoading(false);});
    return ()=>{alive=false;};
  },[open,registerId,permitted]);
  if(!permitted || !detectedCount)return null;
  return <><button type="button" className="mp-gift-trigger" onClick={()=>setOpen(true)}>🎁 Obsequios: {detectedCount} {detectedCount===1?'regalo':'regalos'}</button>
    {open&&<div className="mp-gift-backdrop" onMouseDown={e=>{if(e.target===e.currentTarget)setOpen(false);}} role="presentation"><section className="mp-gift-dialog" role="dialog" aria-modal="true" aria-label="Detalle de obsequios">
      <header><strong>Obsequios de la venta</strong><button type="button" aria-label="Cerrar" onClick={()=>setOpen(false)}>×</button></header>
      {loading?<p>Cargando...</p>:error?<p role="alert">{error}</p>:<div className="mp-gift-items">{rows.map(item=><div key={item.id}><strong>{item.title || "Obsequio"}</strong><span>{item.category} · {item.quantity} unidad(es)</span><small>{item.campaign_name || item.campaign || "Campaña promocional"}</small></div>)}</div>}
      <footer>Entrega promocional sin cobro adicional</footer>
    </section></div>}</>;
}
